// components/ExternalLink.js
import React from 'react';
import { HStack, Image, Link } from '@chakra-ui/react';

export function ExternalLink({ href, logoSrc, altText, children }) {
  // Don't render anything if the link is not available
  if (!href) {
    return null;
  }

  return (
    <HStack spacing={3} align="center">
      <Image
        src={logoSrc}
        alt={altText}
        boxSize="24px"
        objectFit="contain"
      />
      <Link
        href={href}
        isExternal
        color="blue.500"
        fontWeight="medium"
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
      </Link>
    </HStack>
  );
}
